<template>
      <div class="wrapper" v-on:keyup="keyHandler($event)">
          <form class="form-signin"  id="login_dash"  > 
              <div class="d-flex justify-content-center">
                   <!--<img src="/img/computador.png" style="width:90px">-->
                   <img src="/img/logo-topo.png" style="height: 90px;margin-bottom:10px">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-user-o" aria-hidden="true"></i>
                  </span>
                </div>
                <input type="text" class="form-control" placeholder="Email" v-model="email" > 
              </div> 
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input type="password" class="form-control" placeholder="Senha" v-model="senha" > 
              </div>   

              <!--Recaptcha-->
              <g-recaptcha :sitekey='sitekey' :callback="callback" style="margin: 10px 0 10px 0;" ></g-recaptcha>      
              <button class="btn btn-lg btn-primary btn-block" style="margin-top:10px;" type="button" @click="loginForm()">Entrar</button>   
          </form>
      </div>
</template>

<script>
import axios from 'axios';
import store from "src/store.js"
import 'src/controller/loginController.js'
import gRecaptcha from 'src/components/recaptcha.vue'

export default {
    components: {
      gRecaptcha
    },
    data(){
      return {
        email: null,
        senha: null,
        token: null,
        sitekey: '6LeqLNwZAAAAAFhPGHjb_d_yS9KKIxva7v3KSUnl',
      }
    },
    methods:{
      callback(token){
        this.token = token;
      },
      keyHandler (event) {
          // console.log(event);
          let tecla = event.keyCode;
          if(tecla == 13) {
             this.loginForm();
          }
      },
      async loginForm() {
        let data = await this.$Login(this.email,this.senha,this.token);
        this.email= null;
        this.senha= null;
        this.token= null;
        //console.log(data);
        if(data){
          alert('Nome de usuário ou senha errados. Por favor tente outra vez!');
          location.reload();
        }else{
         // alert('Bem vindo!');
          this.token = sessionStorage.getItem("token");
          store.user = this.token;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem("token");
          this.$router.push('/sistema/overview');
        }
        
      }  
    }

}
</script>

<style scoped>
body {
   background: #eee !important;	
}

.wrapper {	
  padding-top: 80px;
  padding-bottom: 80px;
  /*background-color: #5f7fa0;*/
  background-image: url(/img/digital-art.jpg);
  height: 100vh;
}

.form-signin {
  max-width: 380px;
  padding: 15px 35px 45px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.1);  
}
</style>